"use client";

import { ConsentCheckbox } from "@/features/quote/ui/ConsentCheckbox";
import { ContactFields } from "@/features/quote/ui/ContactFields";
import { StepHeading } from "@/features/quote/ui/StepHeading";
import { StepNav } from "@/features/quote/ui/StepNav";
import { useWizard } from "@/features/quote/ui/wizard-context";
import { fieldBaseClass, labelClass } from "@/shared/ui/form/field-styles";
import { Honeypot } from "@/shared/ui/form/Honeypot";
import { SubmitError } from "@/shared/ui/form/SubmitError";

export function ContactStep() {
  const {
    state,
    update,
    goToStep,
    step,
    stepReady,
    isBusiness,
    fieldErrors,
    setFieldError,
    validateEmailField,
    validatePhoneField,
    honeypot,
    setHoneypot,
    submitError,
    isSubmitting,
    handleSubmit,
  } = useWizard();

  return (
    <section>
      <StepHeading
        title={
          isBusiness ? "Hvordan skal firmaet kontakte jer?" : "Hvordan skal firmaet kontakte dig?"
        }
        body={
          isBusiness
            ? "I ser firmaerne med det samme. Det firma, I bliver matchet med, kontakter jer med et uforpligtende tilbud på de oplysninger, I skriver her. Ingen andre får dem."
            : "Du ser firmaerne med det samme. Det firma, du bliver matchet med, kontakter dig med et uforpligtende tilbud på de oplysninger, du skriver her. Ingen andre får dem."
        }
      />

      <Honeypot name="ref_token" value={honeypot} onChange={setHoneypot} />

      {isBusiness ? (
        <div className="mb-5 grid grid-cols-1 gap-3.5 sm:grid-cols-2">
          <div>
            <label htmlFor="wiz-name" className={labelClass}>
              Dit navn
            </label>
            <input
              id="wiz-name"
              type="text"
              autoComplete="name"
              placeholder="Fornavn og efternavn"
              value={state.contactName}
              onChange={(e) => update("contactName", e.target.value)}
              className={fieldBaseClass}
            />
          </div>
          <div>
            <label htmlFor="wiz-company" className={labelClass}>
              Virksomhed
            </label>
            <input
              id="wiz-company"
              type="text"
              autoComplete="organization"
              placeholder="Firmanavn"
              value={state.companyName}
              onChange={(e) => update("companyName", e.target.value)}
              className={fieldBaseClass}
            />
          </div>
        </div>
      ) : (
        <div className="mb-5">
          <label htmlFor="wiz-name" className={labelClass}>
            Dit navn
          </label>
          <input
            id="wiz-name"
            type="text"
            autoComplete="name"
            placeholder="Fornavn og efternavn"
            value={state.contactName}
            onChange={(e) => update("contactName", e.target.value)}
            className={fieldBaseClass}
          />
        </div>
      )}

      <ContactFields
        email={state.email}
        phone={state.phone}
        onEmailChange={(v) => {
          update("email", v);
          if (fieldErrors.email) setFieldError("email", null);
        }}
        onEmailBlur={(v) => setFieldError("email", validateEmailField(v))}
        onPhoneChange={(v) => {
          update("phone", v);
          if (fieldErrors.phone) setFieldError("phone", null);
        }}
        onPhoneBlur={() => setFieldError("phone", validatePhoneField(state.phone))}
        emailError={fieldErrors.email}
        phoneError={fieldErrors.phone}
      />

      <div className="mb-5">
        <label htmlFor="wiz-notes" className={labelClass}>
          Beskriv opgaven <span className="font-normal text-ink-subtle">(valgfrit)</span>
        </label>
        <textarea
          id="wiz-notes"
          rows={4}
          placeholder={
            isBusiness
              ? "Fx 'Vi har brug for natrengøring mandag til fredag' eller særlige forhold ved lokalerne…"
              : "Fx 'Der er 2 badeværelser og et kontor, der skal særligt gennemgås'…"
          }
          value={state.notes}
          onChange={(e) => update("notes", e.target.value)}
          className={`${fieldBaseClass} min-h-24 resize-y`}
        />
      </div>

      <ConsentCheckbox checked={state.consent} onChange={(checked) => update("consent", checked)} />

      <SubmitError message={submitError} />

      <StepNav
        onBack={() => goToStep(step - 1)}
        onNext={handleSubmit}
        nextEnabled={stepReady("contact") && !isSubmitting}
        nextLabel={isSubmitting ? "Finder firma…" : "Få et uforpligtende tilbud"}
      />
    </section>
  );
}
